module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.388938f6.woff";